import { useTranslation } from 'react-i18next';

import { Restaurant } from '@cfa/brand-icons';
import { LocationDetails } from '@cfa/pathway-fe-shared/xp';
import { Button, Card, CardContent, Typography } from '@cfa/react-components';

import Constants from '@/constants';

interface LocationCardProps {
  location: LocationDetails;
  onChoose: () => void;
}

export const LocationCard: React.FC<LocationCardProps> = ({
  location,
  onChoose,
}) => {
  const { t } = useTranslation();

  return (
    <Card
      data-testid="LocationCard"
      elevation={1}
      className="relative my-4 flex h-auto animate-[fadeIn_linear_0.3s] flex-row! overflow-visible p-0!"
    >
      <div
        className="flex h-auto w-20 shrink-0 items-center justify-center rounded-l-[inherit]"
        style={{ backgroundColor: Constants.PLAN_CATEGORY_COLORS.GENERAL }}
      >
        <Restaurant style={{ color: 'white' }} size="md" />
      </div>
      <CardContent className="flex w-full items-center justify-between gap-2 p-4! text-left">
        <div className="flex min-w-0 grow flex-col items-start justify-start overflow-hidden md:justify-center">
          <Typography
            data-testid="LocationNumber"
            fontWeight="bold"
            variant="body1"
            className="line-clamp-2 max-w-full min-w-0 overflow-hidden text-ellipsis"
          >
            {location.number}
          </Typography>
          <Typography data-testid="LocationName" variant="body2">
            {location.name}
          </Typography>
        </div>
        <div className="flex shrink-0 items-center justify-center gap-4">
          <Button
            className="min-w-[58px]! md:min-w-[200px]"
            color="secondary"
            data-testid="chooseLocationButton"
            onClick={onChoose}
            variant="filled"
          >
            {t('Button.choose')}
          </Button>
        </div>
      </CardContent>
    </Card>
  );
};
